/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Math.Angle
 */

module.exports = {

    Between: require('./Between'),
    BetweenPoints: require('./BetweenPoints'),
    BetweenPointsY: require('./BetweenPointsY'),
    BetweenY: require('./BetweenY'),
    CounterClockwise: require('./CounterClockwise'),
    Normalize: require('./Normalize'),
    Random: require('./Random'),
    RandomDegrees: require('./RandomDegrees'),
    Reverse: require('./Reverse'),
    RotateTo: require('./RotateTo'),
    ShortestBetween: require('./ShortestBetween'),
    Wrap: require('./Wrap'),
    WrapDegrees: require('./WrapDegrees')

};
